export const GET_MOBILEBANNERS = "GET_MOBILEBANNERS";
export const FILTER_MOBILEBANNERS = "FILTER_MOBILEBANNERS";
export const ADD_MOBILEBANNER = "ADD_MOBILEBANNER";
export const EDIT_MOBILEBANNER = "EDIT_MOBILEBANNER";
export const GET_MOBILEBANNER = "GET_MOBILEBANNER";
export const RESET_MOBILEBANNER = "RESET_MOBILEBANNER";
export const MOBILEBANNERS_ERROR = "MOBILEBANNERS_ERROR";
